<template>
    <div>
        <b-modal ref="serverinfomodal" modal-class="serverinfo-container" :centered="true" size="lg" :lazy="true" :hide-footer="true" @shown="loadServerInfo" no-fade>
            <div slot="modal-header" class="w-100">
                <b-row>
                    <b-col>
                        <b-form-group class="mode-group">
                            <b-form-radio-group button-variant="outline-custom" buttons v-model="mode" :options="options" class="active"></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col class="text-right">
                        <b-btn size="lg" class="float-right" variant="flat" @click="closeModal">
                            <close-icon class="icon-default close modalclose"></close-icon>
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
            <div class="loading-wrapper" v-if="isLoading">
                <spinner size="medium" message="Loading..."></spinner>
            </div>
            <div class="error-wrapper text-center" v-if="showError">
                We are not able to connect to your WordPress site. Please try again in sometime.
            </div>
            <div v-if="!isLoading && !showError">
                <table class="table" v-if="mode=='server'">
                    <thead>
                        <tr>
                            <th scope="col">Server Configuration</th>
                            <th scope="col">Suggestion</th>
                            <th scope="col">Value</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(serverInfo,key) in serverInfo.serverInfo" :key="key">
                            <th scope="row">{{serverInfo.name}}</th>
                            <td>{{serverInfo.suggeted}}</td>
                            <td>{{serverInfo.status}}</td>
                            <td>{{serverInfo.pass?'Good':'Bad'}}</td>
                        </tr>
                        <tr v-for="(serverInfo,key) in serverInfo.mysqlInfo">
                            <th scope="row">{{serverInfo.name}}</th>
                            <td>{{serverInfo.suggeted}}</td>
                            <td>{{serverInfo.status}}</td>
                            <td>{{serverInfo.pass?'Good':'Bad'}}</td>
                        </tr>
                        <tr v-for="(serverInfo,key) in serverInfo.functionList" :key="key">
                            <th scope="row">{{serverInfo.name}}</th>
                            <td>{{serverInfo.suggeted}}</td>
                            <td>{{serverInfo.status}}</td>
                            <td>{{serverInfo.pass?'Good':'Bad'}}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="table" v-if="mode=='folder'">
                    <thead>
                        <tr>
                            <th scope="col">Relative Path</th>
                            <th scope="col">Suggestion</th>
                            <th scope="col">Value</th>
                            <th scope="col">Owner (UID:GID)</th>
                        </tr>
                    </thead>
                    <!-- {{serverInfo.directoryInfo}} -->
                    <tbody v-if="serverInfo.directoryInfo">
                        <tr v-for="(serverInfo,key) in serverInfo.directoryInfo.status" :key="key">
                            <th scope="row">{{serverInfo.title}}</th>
                            <td>{{serverInfo.suggestion}}</td>
                            <td>{{serverInfo.value}}</td>
                            <td>{{serverInfo.owner}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
    </div>
</template>

<script>
import CloseIcon from '../../assets/close.svg';
export default {
  name: 'serverinfo',
  props: ['site'],
  components: {
    CloseIcon
  },
  data() {
    return {
      serverInfo: [],
      isLoading: false,
      showError: false,
      mode: 'server',
      options: [
        { text: 'Server Info', value: 'server' },
        { text: 'Folder Info', value: 'folder' }
      ]
    };
  },
  methods: {
    loadServerInfo() {
      this.isLoading = true;
      let payload = {};
      payload.action = 'backupTest';
      payload.args = {};
      payload.args.siteIDs = [];
      payload.requiredData = {};
      payload.args.siteIDs.push(this.site.siteID);
      payload.requiredData['iwpLoadServerInfoV3'] = this.site.siteID;
      this.$store.dispatch('sendAction', payload).then(response => {
        this.isLoading = false;
        if (response.data.iwpLoadServerInfoV3 === false) {
          this.showError = true;
          return;
        }
        this.showError = false;
        this.serverInfo = response.data.iwpLoadServerInfoV3;
      });
    },
    closeModal() {
      this.$refs.serverinfomodal.hide();
    }
  }
};
</script>

<style>

</style>
